export const environment = {
  production: true,
  buildId: '3377871584021981',
  configFile: 'config.json',
};
